import React from 'react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import {Spinner} from '../../../spinner'
import s from '../coupon-input.scss'

export const CouponInputSpinner = () => (
  <div data-hook={DH.COUPON_CHECKING_VALIDITY} className={classNames(s.couponValidating)}>
    <Spinner diameter={17} />
  </div>
)
